import { useQuery } from '@tanstack/react-query';
import config from '../config';

/**
 * Custom hook wrappers for TanStack Query with sensible defaults.
 */

/**
 * Hook for standard API queries with auto-refresh.
 */
export function useApiQuery(key, fetchFn, options = {}) {
  return useQuery({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn: fetchFn,
    staleTime: (options.staleTime ?? config.dashboardRefreshInterval),
    refetchInterval: options.refetchInterval ?? false,
    retry: 2,
    ...options,
  });
}

/**
 * Hook for real-time data with 5-second polling.
 */
export function useRealtimeQuery(key, fetchFn, options = {}) {
  return useQuery({
    queryKey: Array.isArray(key) ? key : [key],
    queryFn: fetchFn,
    staleTime: 0,
    refetchInterval: options.refetchInterval ?? config.pollingInterval,
    refetchIntervalInBackground: false,
    retry: 1,
    ...options,
  });
}
